import { useCallback, useState } from "react"

import PopUp from "../PopUp"
import TwoFactorVerification from "./TwoFactorVerification"
import RecoveryCodesVerification from "./RecoveryCodesVerification"

const OTP = "otp"
const RECOVERY = "recovery"
type VerificationTypeType = typeof OTP | typeof RECOVERY

interface OTPVerifierModalProps {
  open: boolean
  onClose: () => void
  onParentClose?: () => void
  otpCode: string
  onVerify: (value: string) => Promise<any>
  isVerifying: boolean
}

const OTPVerifierModal = ({
  open,
  onClose,
  onParentClose = () => {},
  otpCode,
  onVerify,
  isVerifying,
}: OTPVerifierModalProps) => {
  const [verificationType, setVerificationType] = useState<VerificationTypeType>(OTP)
  const handleSwitchVerification = () => {
    setVerificationType((current) => (current == OTP ? RECOVERY : OTP))
  }

  const verify = useCallback(
    (value: string) =>
      onVerify(value).then(() => {
        onClose()
        onParentClose()
      }),
    [onClose, onParentClose, onVerify],
  )

  return (
    <PopUp
      open={open}
      onClose={onClose}
      titleKey={
        verificationType === OTP ? "auth.TWO_FACTOR_AUTH" : "auth.RECOVERY_CODE_AUTH"
      }
      aria-describedby="otp-verifier-description"
      fullWidth
      maxWidth={"sm"}
    >
      {verificationType === OTP ? (
        <TwoFactorVerification
          verify={verify}
          isVerifying={isVerifying}
          otpCode={otpCode}
          handleSwitchVerification={handleSwitchVerification}
        />
      ) : (
        <RecoveryCodesVerification
          verify={verify}
          isVerifying={isVerifying}
          otpCode={otpCode}
          handleSwitchVerification={handleSwitchVerification}
        />
      )}
    </PopUp>
  )
}

export default OTPVerifierModal
